import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/bodega/bodega';
import BodegaCrear from './BodegaEditar';

const mstp = state => {
    return {...state.bodegas}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(BodegaCrear)
